import React, {useContext, useEffect, useState} from 'react';
import Drawer from 'components/Drawer';
import PayerTable from 'features/payer/PayerTable';
import PayerForm from 'features/payer/PayerForm';
import {TitleContext} from '../../components/TitleContext';

const PayersPage: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);
  const {setTitle} = useContext(TitleContext);

  useEffect(() => {
    setTitle(
      <div>
        <div className="text-slate-600 text-lg font-medium font-['Inter']  ">
          Payers
        </div>
        <div className="text-slate-400 text-sm font-light font-['Inter'] leading-normal ">
          Manage your company’s payers
        </div>
      </div>,
    );
  }, [setTitle]);
  return (
    <div className="">
      <div className="relative overflow-hidden">
        <div>
          <div>
            <div className="relative">
              <PayerTable openDrawer={openDrawer} />
              <Drawer isOpen={isDrawerOpen} onClose={closeDrawer}>
                <PayerForm closeDrawer={closeDrawer} />
              </Drawer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayersPage;
